import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layouts/Layout";
import Hero from '../contents/home/hero.mdx';
import Integrations from '../contents/home/integrations.mdx';
import Features from '../contents/home/features.mdx';
import Graphs from '../contents/home/graphTypes.mdx';
import Benefits from '../contents/home/benefits.mdx';
import SEO from '../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Free online diagram builder" mdxType="SEO" />
    <Hero mdxType="Hero" />
    <Integrations mdxType="Integrations" />
    <Features mdxType="Features" />
    <Graphs mdxType="Graphs" />
    <Benefits mdxType="Benefits" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      